import {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {cn} from '@chekinapp/ui';
import {useIVRegistrationGate} from 'hooks';
import {SkipIVModal, SkipIVModalRef} from 'components/common/SkipIVModal';

type Props = {
  className?: string;
};

export function SkipForNow({className}: Props) {
  const {t} = useTranslation();
  const {canSkipIV} = useIVRegistrationGate();
  const skipModalRef = useRef<SkipIVModalRef>(null);

  if (!canSkipIV) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={() => skipModalRef.current?.open()}
        className={cn(
          'whitespace-nowrap text-[13px] font-medium leading-5 text-[var(--chekin-color-gray-1)] transition-colors hover:text-[var(--chekin-color-brand-navy)]',
          className,
        )}
      >
        {t('skip_by_now')}
      </button>
      <SkipIVModal ref={skipModalRef} />
    </>
  );
}
